export default __webpack_public_path__ + "static/media/question.8d929aa4.png";